import { render, staticRenderFns } from "./DisplayStatsPanel.vue?vue&type=template&id=4368467a&scoped=true"
import script from "./DisplayStatsPanel.vue?vue&type=script&lang=js"
export * from "./DisplayStatsPanel.vue?vue&type=script&lang=js"
import style0 from "./DisplayStatsPanel.vue?vue&type=style&index=0&id=4368467a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4368467a",
  null
  
)

export default component.exports